import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FomanticUIModule } from 'ngx-fomantic-ui';
import { MomentModule } from 'ngx-moment';

import { DocorgaLibModule } from '@docorga-v1/docorga-angular';

import { DirectivesModule } from '../directives/directives.module';
import { PipesModule } from '../pipes/pipes.module';
import { DocumentBackgroundPreviewComponent } from './document-background-preview/document-background-preview.component';
import { DocumentImagePreviewComponent } from './document-image-preview/document-image-preview.component';
import { DocumentLinesPreviewComponent } from './document-lines-preview/document-lines-preview.component';
import { DocumentPreviewSantoComponent } from './document-preview-santo/document-preview-santo.component';
import { DocumentPreviewWormComponent } from './document-preview-worm/document-preview-worm.component';
import { DocumentPreviewComponent } from './document-preview/document-preview.component';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { LayoutComponent } from './layout/layout.component';
import { CancelAppointmentModalComponent } from './modals/cancel-appointment/cancel-appointment.component';
import { CreateApplicationModalComponent } from './modals/create-application/create-application.component';
import { CreateFolderModalComponent } from './modals/create-folder/create-folder.component';
import { CreatePatientFolderModalComponent } from './modals/create-patient-folder/create-patient-folder.component';
import { CreatePatientModalComponent } from './modals/create-patient/create-patient.component';
import { DeletePatientModalComponent } from './modals/delete-patient/delete-patient.component';
import { OldAppModalComponent } from './modals/old-app/old-app.component';
import { PatientFolderConfirmationModalComponent } from './modals/patient-folder-confirmation/patient-folder-confirmation.component';
import { PatientFolderHelpModalComponent } from './modals/patient-folder-help/patient-folder-help.component';
import { PaymentErrorModalComponent } from './modals/payment-error/payment-error.component';
import { PaymentSuccessModalComponent } from './modals/payment-success/payment-success.component';
import { SelectExpertizeModalComponent } from './modals/select-expertize/select-expertize.component';
import { SetFollowUpModalComponent } from './modals/set-follow-up/set-follow-up.component';
import { PatientFormComponent } from './patient-form/patient-form.component';
import { SearchPrlComponent } from './search-prl/search-prl.component';
import { SearchComponent } from './search/search.component';
import { TextStylePreviewComponent } from './text-style-preview/text-style-preview.component';
import { ToasterContainerComponent } from './toaster-container/toaster-container.component';

@NgModule({
  imports: [
    CommonModule,
    DirectivesModule,
    FomanticUIModule,
    FormsModule,
    ReactiveFormsModule,
    MomentModule,
    PipesModule,
    RouterModule,
    DocorgaLibModule,
  ],
  declarations: [
    LayoutComponent,
    CreateApplicationModalComponent,
    CreateFolderModalComponent,
    CancelAppointmentModalComponent,
    DeletePatientModalComponent,
    CreatePatientModalComponent,
    CreatePatientFolderModalComponent,
    HeaderComponent,
    FooterComponent,
    DocumentPreviewComponent,
    DocumentPreviewWormComponent,
    DocumentPreviewSantoComponent,
    DocumentBackgroundPreviewComponent,
    DocumentImagePreviewComponent,
    DocumentLinesPreviewComponent,
    TextStylePreviewComponent,
    PatientFormComponent,
    PaymentSuccessModalComponent,
    PaymentErrorModalComponent,
    PatientFolderHelpModalComponent,
    PatientFolderConfirmationModalComponent,
    OldAppModalComponent,
    SearchComponent,
    SearchPrlComponent,
    SelectExpertizeModalComponent,
    SetFollowUpModalComponent,
    ToasterContainerComponent
  ],
  exports: [
    LayoutComponent,
    HeaderComponent,
    FooterComponent,
    DocumentPreviewComponent,
    DocumentPreviewWormComponent,
    DocumentPreviewSantoComponent,
    DocumentBackgroundPreviewComponent,
    DocumentImagePreviewComponent,
    DocumentLinesPreviewComponent,
    TextStylePreviewComponent,
    SearchComponent,
    SearchPrlComponent,
    ToasterContainerComponent,
    PatientFormComponent
  ]
})
export class ComponentsModule {}
